export const API_URL = process.env.VUE_APP_API_URL;
export const API_WS_URL = process.env.VUE_APP_API_WS_URL;
// export const API_URL = 'https://documents.gladsal.com/api';
// export const API_WS_URL = 'https://documents.gladsal.com/api/ws';
export const ROUT_HOME = '/';
export const ROUT_AUTH = '/auth';
export const ROUT_FOREIGN = '/foreign';
export const ROUT_TRASH = '/trash';
export const ROUT_USERS = '/users';
export const API_ROUT_USER = '/user';
export const API_ROUT_USER_CREATE = '/user/register';
export const API_ROUT_USER_LOGIN = '/user/login';
export const API_ROUT_USER_ISLOGIN = '/user/islogin';
export const API_ROUT_USER_ACCESS = '/user/access';
export const API_ROUT_USER_RESET = '/user/reset';
export const API_ROUT_USER_LOGOUT = '/user/logout';
export const API_ROUT_NODES = '/node';
export const API_ROUT_NODE_CREATE = '/node/create';
export const API_ROUT_NODE_UPLOAD = '/node/upload';
export const API_ROUT_NODE_DOWNLOAD = '/node/download';
export const API_ROUT_NODE_VIEW = '/node/view';
export const API_ROUT_NODE_UNARCHIVE = '/node/unarchive';
export const TIMEZONE = 'Europe/Kyiv';

export const ROOT_DIR_NAME = 'Корнева папка';
export const TRASH_DIR_NAME = 'Кошик';

// -to-do- Вынести на сервер
export const ALLOW_FILE_FORMATS = [
    // === Изображения ===
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/bmp',
    'image/tiff',
    'image/x-icon',
    'image/svg+xml',
    'image/heic',
    'image/heif',

    // === Текст и документы ===
    'text/plain',
    'text/csv',
    'text/html',
    'text/xml',
    'application/pdf',
    'application/rtf',
    'application/msword',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.text-template',
    'application/x-pkcs12',
    
    // === ЕПЦ ===
    'application/pkcs7-signature',

    // === Таблицы ===
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.spreadsheet-template',
    'application/vnd.oasis.opendocument.spreadsheet-flat-xml',

    // === Презентации ===
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.oasis.opendocument.presentation',

    // === Архивы и пакеты ===
    'application/zip',
    'application/x-7z-compressed',
    'application/x-rar-compressed',
    'application/x-tar',
    'application/gzip',
    'application/x-bzip2',
    'application/x-xz',
    'application/vnd.apple.installer+xml',
    'application/vnd.rar',

    // === Электронные книги ===
    'application/epub+zip',
    'application/x-mobipocket-ebook',

    // === Аудио ===
    'audio/mpeg',
    'audio/wav',
    'audio/ogg',
    'audio/flac',
    'audio/aac',
    'audio/mp4',
    'audio/webm',

    // === Видео ===
    'video/mp4',
    'video/webm',
    'video/x-msvideo',
    'video/ogg',
    'video/quicktime',
    'video/mpeg',
];

export const mimeTypeMap: Record<string, string> = {
    // === Изображения ===
    'image/jpeg': 'jpeg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'image/bmp': 'bmp',
    'image/tiff': 'tiff',
    'image/x-icon': 'ico',
    'image/svg+xml': 'svg',
    'image/heic': 'heic',
    'image/heif': 'heif',

    // === Текст и документы ===
    'text/plain': 'txt',
    'text/csv': 'csv',
    'text/html': 'html',
    'text/xml': 'xml',
    'application/pdf': 'pdf',
    'application/rtf': 'rtf',
    'application/msword': 'doc',
    'application/vnd.ms-word.document.macroEnabled.12': 'docm',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'dotx',
    'application/vnd.oasis.opendocument.text': 'odt',
    'application/vnd.oasis.opendocument.text-template': 'ott',
    'application/x-pkcs12': 'pfx/p12',

    // === ЕПЦ ===
    'application/pkcs7-signature': 'p7s',

    // === Таблицы ===
    'application/vnd.ms-excel': 'xls',
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xltx',
    'application/vnd.oasis.opendocument.spreadsheet': 'ods',
    'application/vnd.oasis.opendocument.spreadsheet-template': 'ots',
    'application/vnd.oasis.opendocument.spreadsheet-flat-xml': 'fods',

    // === Презентации ===
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'pptm',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.openxmlformats-officedocument.presentationml.template': 'potx',
    'application/vnd.oasis.opendocument.presentation': 'odp',

    // === Архивы и пакеты ===
    'application/zip': 'zip',
    'application/x-7z-compressed': '7z',
    'application/x-rar-compressed': 'rar',
    'application/vnd.rar': 'rar',
    'application/x-tar': 'tar',
    'application/gzip': 'gz',
    'application/x-bzip2': 'bz2',
    'application/x-xz': 'xz',
    'application/vnd.apple.installer+xml': 'mpkg',

    // === Электронные книги ===
    'application/epub+zip': 'epub',
    'application/x-mobipocket-ebook': 'mobi',

    // === Аудио ===
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'audio/ogg': 'ogg',
    'audio/flac': 'flac',
    'audio/aac': 'aac',
    'audio/mp4': 'm4a',
    'audio/webm': 'weba',

    // === Видео ===
    'video/mp4': 'mp4',
    'video/webm': 'webm',
    'video/x-msvideo': 'avi',
    'video/ogg': 'ogv',
    'video/quicktime': 'mov',
    'video/mpeg': 'mpeg',
};

export const getMimeTypeName = (mimeType: string): string => {
    return mimeTypeMap[mimeType] || 'Невідомий формат';
};

export const getAllMimeTypeNames = (): string[] => {
    return Array.from(new Set(Object.values(mimeTypeMap)));
};

export const getMimeTypesByName = (name: string): string[] => {
    return Object.keys(mimeTypeMap).filter(key => mimeTypeMap[key] === name);
};

export const isMimeTypeArchive = (mimeType: string): boolean => {
    return [
        'application/zip',
        'application/x-7z-compressed',
        'application/x-rar-compressed',
        'application/x-tar',
        'application/gzip',
        'application/x-bzip2',
        'application/x-xz',
        'application/vnd.apple.installer+xml',
        'application/vnd.rar',
    ].includes(mimeType);
};

export const ALLOW_FILE_VIEW = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'text/xml',
    'application/msword',
    'text/plain',
    'application/vnd.ms-word.document.macroEnabled.12',
    'image/x-icon',
    'image/svg+xml',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.spreadsheet-template',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel',
    'text/html',
    'text/csv',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
];

export const ALLOW_EDITOR_ROUTS = [ROUT_HOME];


